import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader2 from "../component/Loader2";

const isJwtExpired = (token) => {
  try {
    const parts = String(token || "").split(".");
    if (parts.length !== 3) return true;

    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const normalized = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      "=",
    );
    const payload = JSON.parse(atob(normalized));
    const exp = Number(payload?.exp);

    if (!exp) return true;
    return Date.now() >= exp * 1000;
  } catch (e) {
    return true;
  }
};

const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let loginData = null;
    try {
      loginData = JSON.parse(localStorage.getItem("sharedData"));
    } catch (e) {
      loginData = null;
    }

    console.log("privateRoute sharedData:", loginData);

    if (cancelled) return;

    if (!loginData?.accessToken) {
      console.log("privateRoute missing accessToken");
      toast.error("Please login first.");
      navigate("/");
      setIsLoading(false);
      return;
    }

    if (isJwtExpired(loginData.accessToken)) {
      console.log("Access token expired");
      toast.error("Session expired. Please login again.");
      localStorage.removeItem("sharedData");
      navigate("/");
      setIsLoading(false);
      return;
    }

    console.log("User authorized successfully");
    setIsAuthorized(true);
    setIsLoading(false);

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (isLoading) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255,255,255,0.9)",
          zIndex: 9999,
        }}
      >
        <Loader2 />
      </div>
    );
  }

  return isAuthorized ? children : null;
};

export default PrivateRoute;
